import { ActionResponse, ActionStatusHelper, RecordMap, useAuditEnricher } from "@/Shared";
import {
    useProperty
} from "@/OneLiners";
import { PublicationModel } from "../Models/PublicationModel";

export function usePublicationEnricher() {

    const { 
        dataMap: propertyMap, 
        stateResponse : propertyResponse
    } = useProperty();

    /**
         * Centralized audit enrichment hook
         * - Provides O(1) user resolution via precomputed Map
         * - Exposes audit enrichment helpers and status/error
         */
    const {
        enricherResponse: auditEnricherResponse,
        userMap,
        getUserById,
        getEnrichedAudit,
    } = useAuditEnricher<PublicationModel>();

    const enricherResponse: ActionResponse = {
        status: ActionStatusHelper.combine(
            auditEnricherResponse.status,
            propertyResponse.status
        ),

        error: auditEnricherResponse.error ??
            propertyResponse.error
    };

     const getEnrichedPublicationMap = (publicationMap: RecordMap<PublicationModel>): RecordMap<PublicationModel> => {
                        
                        return publicationMap.map<PublicationModel>(getStrictEnrichedPublication);
                    }
        

    const getEnrichedPublicationById = (publicationMap: Map<number, PublicationModel>,
        publicationId: number): PublicationModel | undefined => {
        return getEnrichedPublication(publicationMap.get(publicationId));
    }

    const getEnrichedPublication = (publication?: PublicationModel): PublicationModel | undefined => {
        return publication ? getStrictEnrichedPublication(publication) : undefined;
    }


    const getStrictEnrichedPublication = (publication: PublicationModel): PublicationModel => {
        return {
            ...getEnrichedAudit(publication),
            property: propertyMap.get(publication.propertyId)
        }
    }

    return {
        enricherResponse,
        userMap,
        propertyMap,
        getEnrichedPublication,
        getStrictEnrichedPublication,
        getEnrichedPublicationById,
        getEnrichedPublicationMap,
    }
}